import { createSlice } from "@reduxjs/toolkit"

/**
 * @fileoverview This file defines a Redux slice for managing selected rows in a table.
 * @author Hrashini
 */
const initialState = {
  selectedRows: [],
}

const tableSlice = createSlice({
  name: "tableSlice",
  initialState,
  reducers: {
    /**
     * Adds selected rows to the state.
     * @param {Object} state - Current state of the slice.
     * @param {Object} action - The action payload containing selected rows.
     */
    addSelectedRow: (state, action) => {
      state.selectedRows = action.payload
    },
    /**
    * Removes a row from the selected rows based on the key.
    * @param {Object} state - Current state of the slice.
    * @param {Object} action - The action payload containing the key to remove.
    */
    removeSelectedRow: (state, action) => {
      state.selectedRows = state.selectedRows.filter(
        row => row.key !== action.payload,
      )
    },
    /**
     * Resets all selected rows to an empty array.
     * @param {Object} state - Current state of the slice.
     */
    resetSelectedRows: state => {
      state.selectedRows = []
    },
  },
})

export const { addSelectedRow, removeSelectedRow, resetSelectedRows } =
  tableSlice.actions
export default tableSlice.reducer
